import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Login from './js/Login'
import Main from './js/Main'
import NewContractDocument from './js/NewContractDocument'
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import UpdateTable from './js/UpdateTable';
import ReactPDF, { PDFViewer } from '@react-pdf/renderer';
import ReplaceContractDocument from './js/ReplaceContractDocument';
import RemoveContractDocument from './js/RemoveContractDocument';

ReactDOM.render(
  <Router>
    <Switch>
      <Route exact path="/">
        <Main/>
      </Route>
      <Route path='/login'>
        <Login/>
      </Route>
      <Route path = '/insert'>
        <UpdateTable/>
      </Route>
      <Route path = '/pdf/new/:id/:firstname/:lastname/:personal_number' children={ <NewContractDocument />}/>
      <Route path = '/pdf/replace/:id/:firstname/:lastname/:personal_number' children={ <ReplaceContractDocument />}/>
      <Route path = '/pdf/remove/:id/:firstname/:lastname/:personal_number' children={ <RemoveContractDocument />}/>
    </Switch>
  </Router>
  ,
  document.getElementById('root')
);
serviceWorker.unregister();
